export default __webpack_public_path__ + "static/media/goshen47.642d728c.jpg";